import React, { useState } from "react";
import PodSupportModal from "./PodSupportModal";
import { formatDate, formatTime, toSentence, toTitle } from "./trackingUtils";

/** "Kolkata - 700013" (city and/or pincode, whichever is available) */
const formatPlace = (loc) =>
  [loc?.city && toTitle(loc.city), loc?.pincode].filter(Boolean).join(" - ") || null;

const Field = ({ label, value, className = "" }) => (
  <div className="detail-field">
    <div className="detail-label">{label}</div>
    <div className={`detail-value ${className}`}>{value || "—"}</div>
  </div>
);

const ShipmentDetails = ({ info, summary, podLink }) => {
  const referenceNo = info?.referenceNo || info?.referenceNumber || info?.refNo;
  const expectedToday = summary.state === "ofd" && summary.headline === "Arriving today";
  const [showPodModal, setShowPodModal] = useState(false);

  return (
    <section className="card details">
      <h2 className="card-title">Shipment Details</h2>
      <div className="details-grid">
        <Field label="Booked on" value={summary.bookedAt && formatDate(summary.bookedAt)} />
        {referenceNo ? <Field label="Reference no" value={referenceNo} /> : <div />}
        <Field label="From" value={formatPlace(info?.sourceLocation)} />
        <Field label="To" value={formatPlace(info?.destinationLocation)} />
        <Field label="Status" value={toSentence(summary.badge)} className={`tone-text-${summary.tone}`} />
        <div />
        <Field
          label="Date of delivery"
          value={
            summary.deliveredAt
              ? formatDate(summary.deliveredAt)
              : expectedToday
              ? "Expected today"
              : null
          }
          className={summary.deliveredAt ? "" : "pending"}
        />
        <Field
          label="Time of delivery"
          value={summary.deliveredAt ? formatTime(summary.deliveredAt) : null}
          className={summary.deliveredAt ? "" : "pending"}
        />
      </div>

      {podLink && (
        <button type="button" className="btn-outline btn-block" onClick={() => setShowPodModal(true)}>
          View proof of delivery
        </button>
      )}

      {showPodModal && (
        <PodSupportModal trackingId={info?.trackingId} onClose={() => setShowPodModal(false)} />
      )}
    </section>
  );
};

export default ShipmentDetails;
